module.exports = new __parcel__URL__("oco2-mip-co2budget-yeargrid-v1.thumbnails.net.carbon.exchange.6bf42494.png").toString();